import type { Reducer } from 'redux';
import { loadInitialSalesDealerships } from './dealershipsInitialState';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import { CLEAR_ROLE_ASSUMPTION } from '@makemydeal/dr-activities-role-assumption';
import { bootstrapActionTypes, initActionTypes } from '@makemydeal/dr-shared-store';
import { Actions } from '../actionTypes/actionTypes';
import type { DealershipsState } from './types';

export const dealerships: Reducer<DealershipsState> = (
    state: DealershipsState = { ...loadInitialSalesDealerships() },
    action: any
) => {
    const { payload, type } = action;

    switch (type) {
        case bootstrapActionTypes.BOOTSTRAP_INITIAL_LOAD: {
            return {
                ...state,
                requestStatus: ApiRequestStatus.Loading
            };
        }
        case initActionTypes.INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                currentDealership: payload.dealerDetails?.currentDealership,
                availableDealerships: payload.dealerDetails?.availableDealerships,
                isEmployee: payload.isEmployee ? payload.isEmployee : false,
                requestStatus: !payload.dealerDetailsError ? ApiRequestStatus.Success : ApiRequestStatus.Error
            };
        }
        case CLEAR_ROLE_ASSUMPTION: {
            return {
                ...state,
                availableDealerships: [],
                isEmployee: true,
                requestStatus: ApiRequestStatus.Idle
            };
        }
        case Actions.SET_ASSUMED_DEALERSHIPS: {
            return {
                ...state,
                availableDealerships: payload.availableDealerships,
                ...(payload.currentDealership ? { currentDealership: payload.currentDealership } : {}),
                requestStatus: ApiRequestStatus.Success
            };
        }
        default: {
            return state;
        }
    }
};
